// Color
export const DUWA_COLOR = "hsl(0, 60%, 70%)";
export const YIRRIDJDJA_COLOR = "hsl(40, 70%, 70%)";
export const MOTHER_CHILD_COLOR = "hsl(66, 50%, 50%)";
export const MARRIAGE_1_COLOR = "hsl(20, 70%, 70%)";
export const MARRIAGE_2_COLOR = "hsl(20, 70%, 70%)";

// Padding
export const PADDING = 0;
